module.exports = __webpack_public_path__ + "static/media/play.f44aab0f.svg";